import { render, staticRenderFns } from "./warning.vue?vue&type=template&id=6d50f17c&scoped=true"
import script from "./warning.vue?vue&type=script&lang=js"
export * from "./warning.vue?vue&type=script&lang=js"
import style0 from "./warning.vue?vue&type=style&index=0&id=6d50f17c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d50f17c",
  null
  
)

export default component.exports